<div class="progetta-pratica-container">
  <div class="loading-overlay" *ngIf="isLoading">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <div class="iframe-container">
    <iframe 
      #iframeElement
      [src]="urlViewer" 
      frameborder="0" 
      allowfullscreen
      allow="clipboard-read *; clipboard-write *; geolocation *; camera *; microphone *; payment *"
      (load)="onIframeLoad()">
    </iframe>
  </div>
</div>
